import { ApplicationConfig } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CountingService } from '@core/services/counting-service/counting-service.service';
import { FeatureToggleService } from '@core/services/feature-toggle-service/feature-toggle-service.service';
import { FloatingInfoService } from '@core/services/floating-info-service/floating-info-service.service';
import { ImageManipulationService } from '@core/services/image-manipulation-service/image-manipulation-service.service';
import { IntegrationUpdateService } from '@core/services/integration-update-service/integration-update-service.service';
import { Ki67Service } from '@core/services/ki67-service/ki67-service.service';
import { PingService } from '@core/services/ping-service/ping-service.service';
import { ReportingService } from '@core/services/reporting-service/reporting-service.service';
import { SoundsService } from '@core/services/sounds-service/sounds-service.service';
import { SplitScreenService } from '@core/services/split-screen-service/split-screen-service.service';
import { TabIdentifier } from '@core/services/tab-identifier/tab-identifier.service';
import { provideToastr } from 'ngx-toastr';
import { HttpRequestInterceptor } from '../core/interceptors/http-request-interceptor.interceptor';
import { AnnotationManagerService } from '../core/services/annotation-manager-service/annotation-manager-service.service';
import { AuthService } from '../core/services/auth-service/auth-service.service';
import { DiscussionService } from '../core/services/discussion-service/discussion-service.service';
import { ExamService } from '../core/services/exam-service/exam-service.service';
import { InferenceService } from '../core/services/inference-service/inference-service.service';
import { SlideService } from '../core/services/slide-service/slide-service.service';
import { TenantService } from '../core/services/tenant-service/tenant-service.service';
import { WebsocketService } from '../core/services/websocket-service/websocket-service.service';
import { routes } from './app.routes';
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(MatIconRegistry),
    provideNativeDateAdapter(),
    provideToastr({
      closeButton: true,
      positionClass: 'toast-bottom-right',
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    ExamService,
    AnnotationManagerService,
    InferenceService,
    SlideService,
    WebsocketService,
    AuthService,
    DiscussionService,
    TenantService,
    SoundsService,
    IntegrationUpdateService,
    ReportingService,
    TabIdentifier,
    CountingService,
    FeatureToggleService,
    ImageManipulationService,
    FloatingInfoService,
    PingService,
    SplitScreenService,
    Ki67Service,
  ],
};
